module.exports = __webpack_public_path__ + "pc/img/swiper_07.36e7c8c6.jpg";